import 'jquery-lazyload';

$(document).ready(function () {

    $(".carousel").carousel("pause");

    $(".mobile-navigation > .breadcrumb > li:nth-child(2)").addClass("breadcrumb-item-first");
    // $('.checkout .payment-method-select ul.method-list li:not(.payment-selected)').click(function() {
    // 	$(".checkout-rightside .sticky-element.bg-white > div > .btn.btn-block.btn-primary.btn-appearance").text('Kaufen');
    // 	$('.checkout li[data-id="6006"]').removeClass("payment-selected");
    // });
    // $('.checkout li[data-id="6006"]').click(function() {
    // 	$(".checkout-rightside .sticky-element.bg-white > div > .btn.btn-block.btn-primary.btn-appearance").text('Ratenoptionen abschließen');
    // 	$('.checkout li[data-id="6006"]').addClass("payment-selected");
    // });

    if ($(".page-category .thumb-inner .isNotMain .add-to-basket-lg-container").attr('data-original-title') == 'Details ansehen') {
        $(".page-category .thumb-inner .isNotMain .add-to-basket-lg-container").attr('data-original-title', 'Design anpassen');
    }

    $('.page-category .thumb-inner .isNotMain .category-list-view-port .btn-outline-primary.mobile-width-button > span').each(function () {
        if ($(this).text() == 'Details ansehen') {
            $(this).text('Design anpassen');
        }
    });

    $(".list-item-carousel").each(function () {
        $(this).owlCarousel({
            autoHeight: true,
            dots: false,
            items: 4,
            lazyLoad: true,
            loop: false,
            margin: 10,
            mouseDrag: true,
            nav: true,
            navClass: [
                "owl-single-item-nav left carousel-control list-control-special", "owl-single-item-nav right carousel-control list-control-special"
            ],
            navContainerClass: "",
            navText: [
                "<i class=\"owl-single-item-control fa fa-angle-left\" aria-hidden=\"true\"></i>", "<i class=\"owl-single-item-control fa fa-angle-right\" aria-hidden=\"true\"></i>"
            ],
            smartSpeed: 350,
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 544 up
                544: {
                    items: 2,
                    slideBy: 2
                },
                // breakpoint from 768 up
                768: {
                    items: 4,
                    slideBy: 4
                }
            },
            onTranslated: function (elem) {
                $(".lazy").lazyload();
            }
        });
    });

    $(".crossselling-list-carousel").each(function () {
        $(this).owlCarousel({
            autoHeight: false,
            dots: false,
            items: 3,
            lazyLoad: false,
            loop: false,
            margin: 10,
            mouseDrag: true,
            nav: true,
            navClass: [
                "owl-single-item-nav left carousel-control list-control-special", "owl-single-item-nav right carousel-control list-control-special"
            ],
            navContainerClass: "",
            navText: [
                "<i class=\"owl-single-item-control fa fa-angle-left\" aria-hidden=\"true\"></i>", "<i class=\"owl-single-item-control fa fa-angle-right\" aria-hidden=\"true\"></i>"
            ],
            smartSpeed: 350,
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 544 up
                544: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 768 up
                768: {
                    items: 3,
                    slideBy: 3
                }
            },
            onTranslated: function (elem) {
                $(".lazy").lazyload();
            }
        });
    });


    if(!!document.getElementById('header-features')){

        document.querySelector("body").classList.add("header-features-active")
    }


    $(".home-quicklinks").each(function () {
        $(this).owlCarousel({
            autoHeight: false,
            dots: false,
            items: 7,
            lazyLoad: true,
            loop: false,
            mouseDrag: true,
            nav: true,
            navClass: [
                "owl-single-item-nav left carousel-control list-control-special", "owl-single-item-nav right carousel-control list-control-special"
            ],
            navContainerClass: "",
            navText: [
                "<i class=\"owl-single-item-control fa fa-angle-left\" aria-hidden=\"true\"></i>", "<i class=\"owl-single-item-control fa fa-angle-right\" aria-hidden=\"true\"></i>"
            ],
            smartSpeed: 350,
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 544 up
                544: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 768 up
                768: {
                    items: 4,
                    slideBy: 3
                },
                992: {
                    items: 7
                }
            },
            onTranslated: function (elem) {
                $(".lazy").lazyload();
            }
        });
    });


    $("#single-feedback").click(function () {
        $('html, body').animate({
            scrollTop: $(".feedback-container").offset().top - 120
        }, 1000);
    });

    $("#versandClick1").click(function () {
        $('html, body').animate({
            scrollTop: $("#Deutschland").offset().top - 150
        }, 1000);
    });
    $("#versandClick2").click(function () {
        $('html, body').animate({
            scrollTop: $("#ATBENL").offset().top - 150
        }, 1000);
    });
    $("#versandClick3").click(function () {
        $('html, body').animate({
            scrollTop: $("#Schweiz").offset().top - 150
        }, 1000);
    });

    $(".f-mail-b").click(function () {
        var newslettermail = $(".f-mail").val();
        $("#mce-EMAIL").val(newslettermail);
    });

});

$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 120) {
        $(".fixed-top").addClass("scrolled");
    } else {
        $(".fixed-top").removeClass("scrolled");
    }
});

$(window).on("load", function () {
    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        }
        return decodeURI(results[1]) || 0;
    }
    if ($.urlParam('c') === 'feedback') {
        $('html, body').animate({
            scrollTop: $("#dewall-feedback").offset().top - 150
        }, 1000);
    }

});
$(document).ready(function () {
    // $("body").on('DOMSubtreeModified', ".notification-wrapper", function () {
    //     var alertError = $(".alert-danger > div").html().split("<hr>");
    //     $(".alert-danger > div").html(alertError[2]);
    // });
// $(".variation-select select").change(function () {
// 	function explode(){
// 	  $('.order-property-custom-inner select').prop('selectedIndex',0);
// 	}
// 	setTimeout(explode, 2000);
// });
    document.addEventListener("onVariationChanged", function () {
        var slcts = vueApp.$children.find(o => {
            return o.$options.template === "#vue-single-item"
        }).$children.filter(s => s.template === "#vue-order-property-list")[0].$children.filter(s => s.template === "#vue-order-property-list-group");
        console.log("slcts", slcts);
        slcts.forEach(function (item) {
            var myComponent = item.$children.find(o => {
                return o.$options.template === "#vue-order-property-list-item"
            });
            myComponent.selectionValue = null;
        });
    });

    if ($("#page-body > div[data-plim='pattern']").length > 0) {
        $(".item-description").remove();
    }

    let isScrolled = false;
    if(!!document.querySelector(".page-singleitem")){
        window.addEventListener("scroll", function(){
            if(!isScrolled){
                window.ceresStore.dispatch('loadComponent', 'login-modal');
                isScrolled = true;
            }
        })
    }
});
// $(document).ready(function() {
// 	var itemname = $(".title span").text().trim();
// 	$("input[name='artikelname']").val(itemname);


// 	var itemid = $(".articlenumber > span").text().replace(/ /g,'');
// 	$("input[name='artikelnummer']").val(itemid);


// 	if ($(".single-carousel img.owl-lazy").attr("src") == "http://www.dewall-design.de/images/produkte/no_image.png") {
// 		$("img.owl-lazy").attr("src", "https://cdn03.plentymarkets.com/h4jadyynyi2a/frontend/ceres/noname.jpg");
// 	}
// 	if ($("#thumb-carousel img.owl-thumb").attr("src") == "http://www.dewall-design.de/images/produkte/no_image.png") {
// 		$("#thumb-carousel img.owl-thumb").attr("src", "https://cdn03.plentymarkets.com/h4jadyynyi2a/frontend/ceres/noname-thumb.jpg");
// 	}

// });
$(document).ready(function () {
    var e = $(".title span").text().trim();
    $("input[name='artikelname']").val(e);
    var t = $(".articlenumber > span").text().replace(/ /g, "");
    $("input[name='artikelnummer']").val(t), "http://www.dewall-design.de/images/produkte/no_image.png" == $(".single-carousel img.owl-lazy").attr("src") && $("img.owl-lazy").attr("src", "https://cdn03.plentymarkets.com/h4jadyynyi2a/frontend/ceres/noname.jpg"), "http://www.dewall-design.de/images/produkte/no_image.png" == $("#thumb-carousel img.owl-thumb").attr("src") && $("#thumb-carousel img.owl-thumb").attr("src", "https://cdn03.plentymarkets.com/h4jadyynyi2a/frontend/ceres/noname-thumb.jpg")
});

document.addEventListener('DOMContentLoaded', function () {

    var vueApp     = document.getElementById("vue-app");
    var pageHeader = document.getElementById("page-header");

    if (!!vueApp && !!pageHeader) {

    }

}, false);
